/**
 * Данные о теплофизических свойствах различных типов окон
 * 
 * uValue - коэффициент теплопередачи окна (Вт/(м²·°C))
 * description - описание типа окна
 * gValue - солнечный фактор остекления (доля солнечной энергии, проходящей через окно)
 * airTightness - воздухопроницаемость (кг/(м²·ч))
 */

export const windowTypes = {
    // Старые типы окон
    'single_glazed': {
      name: 'Одинарное остекление',
      uValue: 5.8,
      description: 'Одинарное стекло в деревянной или металлической раме',
      gValue: 0.85,
      airTightness: 15.0
    },
    'double_glazed_old': {
      name: 'Двойное остекление (старые рамы)',
      uValue: 2.9,
      description: 'Два отдельных переплета с одинарным остеклением',
      gValue: 0.75,
      airTightness: 10.0
    },
    
    // Современные типы окон
    'double_glazed_modern': {
      name: 'Двухкамерный стеклопакет',
      uValue: 1.5,
      description: 'Два стекла в одной раме (обычное стекло)',
      gValue: 0.75,
      airTightness: 5.0
    },
    'double_glazed_low_e': {
      name: 'Двухкамерный с энергосбережением',
      uValue: 1.3,
      description: 'Два стекла, одно с низкоэмиссионным напылением',
      gValue: 0.65,
      airTightness: 4.0
    },
    'triple_glazed': {
      name: 'Трехкамерный стеклопакет',
      uValue: 1.0,
      description: 'Три стекла в одной раме (обычное стекло)',
      gValue: 0.7,
      airTightness: 3.0
    },
    
    // Энергоэффективные типы окон
    'triple_glazed_low_e': {
      name: 'Трехкамерный с энергосбережением',
      uValue: 0.8,
      description: 'Три стекла, одно или два с низкоэмиссионным напылением',
      gValue: 0.6,
      airTightness: 2.0
    },
    'triple_glazed_argon': {
      name: 'Трехкамерный с аргоновым наполнением',
      uValue: 0.6,
      description: 'Три стекла с низкоэмиссионным напылением и аргоновым наполнением',
      gValue: 0.5,
      airTightness: 1.5
    }
  };